/* eslint-disable react/no-deprecated */
import React, { Component } from 'react';
import _ from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import AddIcon from '@material-ui/icons/Add';
import { connect } from 'react-redux';
import {
  Title,
  Button,
  ExpandablePanel,
  TableFooter,
  CategoryModal,
  OptionList,
  EmptyView
} from '../../components';
import { styles } from './Categories.styles';
import { checkAccess } from '../../utils/admins';
import * as actions from '../../actions/index';
import {
  handleRemoveCategorie,
  handleModifyCategorie,
  closeModal,
  handleChangeExpend,
  handleDuplicateCategorie,
  deleteCategorie
} from './Categories.services';
import { mainColor, PRODUCT, SPLASH } from '../../constants';
import { isObjectNotEmpty } from '../../utils/tools';
import { ReactComponent as ImportedSVG } from '../../assets/pictures/box.svg';
import { EMPTY_DESIGN_OPTIONS_TEXT, EMPTY_DESIGN_OPTIONS_TITLE } from '../../constants/dishopInfo';
import ShopModal from '../../components/ShopModal';
import { handleSynchronisationToggle, debouncedUpdate } from '../../utils/shopUtils';
import { checkIntegrationAccess, hasExternalIntegration } from 'src/utils/externalIntegration';
import store from '../../utils/store';
import { listenMenusPOSRealTime } from '../../apis/firebase';
const INITIAL_STATE = {
  isLoading: false,
  synchronize: false,
  createCategorie: false,
  items: {},
  category: {
    name: '',
    description: ''
  },
  item: '',
  showAddCategoryModal: false,
  showModal: false
};
class Categories extends Component {
  constructor() {
    super();
    this.state = INITIAL_STATE;
  }
  async componentDidMount() {
    await debouncedUpdate(this.props.menu);
    await listenMenusPOSRealTime(store.dispatch, this.props.shopId);
  }
  async componentWillReceiveProps(nextProps) {
    const { menu, shopId } = nextProps;
    const { menu: oldMenu, shopId: oldShopId } = this.props;
    if (!_.isEqual(oldMenu?.categories, menu?.categories)) {
      await debouncedUpdate(menu);
    }
    if (!_.isEqual(oldShopId, shopId)) {
      await listenMenusPOSRealTime(store.dispatch, shopId);
    }
  }
  renderOptionList = (categoryKey, items) => {
    return <OptionList key={categoryKey} options={items} categoryKey={categoryKey} />;
  };

  createTableRow = () => {
    const { expanded } = this.state;
    const { categories = {}, page } = this.props;
    const { numPage, rowsPerPage } = page;
    const renderCategories =
      categories &&
      _.keys(categories)
        .sort((a, b) => categories[a]?.name?.localeCompare(categories[b].name))
        .slice(numPage * rowsPerPage, numPage * rowsPerPage + rowsPerPage);
    return renderCategories.map((categoryKey, index) => {
      const { max = '', items = {}, multiple = false, min = '' } = categories[categoryKey];
      const choiceType = (
        <>
          {multiple ? 'Choix multiple' : 'Choix unique'}
          <p style={{ color: mainColor.colorBlack }}>
            {min >= 1 ? `Obligatoire` : `Optionnel`}
            {!max ? (min <= 1 ? ' sans limite' : ` avec minimum ${min} items`) : ''}
            {max > 1 ? (min > 0 ? ` entre ${min} et ${max} items` : ` avec ${max} items max`) : ''}
          </p>
        </>
      );
      return (
        <ExpandablePanel
          expanded={expanded === index}
          onExpand={(e, expanded) => handleChangeExpend(e, expanded, index, this)}
          onRemove={() => { handleRemoveCategorie(categoryKey, this); this.setState({ showModal: false, synchronize: false }) }}
          onUpdate={() => handleModifyCategorie(categoryKey, this)}
          onDuplicate={() => handleDuplicateCategorie(categories[categoryKey], this)}
          renderItems={() => this.renderOptionList(categoryKey, items)}
          item={{ ...categories[categoryKey], description: choiceType }}
        />
      );
    });
  };

  renderCreateCategoryButton = () => {
    return (
      <Button
        className='btn-xs-block mx-3'
        color='primary'
        disabled={!checkAccess('features', 'productAndOption') || checkIntegrationAccess('category', 'hideCreateCategory')}
        onClick={() =>
          this.setState({
            createCategorie: true,
            category: hasExternalIntegration(this.props.shopId) === SPLASH ? { type: PRODUCT } : {},
            showAddCategoryModal: true
          })
        }
      >
        <div className='row justify-content-center align-items-center mr-0 ml-0'>
          <AddIcon />
          <p className='m-0 ml-1'> Créer une nouvelle liste d'options</p>
        </div>
      </Button>
    );
  };
  renderShops = (classes, shopId) => {
    const { showModal, selectedShops = {}, isLoading } = this.state;
    return (
      <ShopModal
        classes={classes}
        shopId={shopId}
        showModal={showModal}
        selectedShops={selectedShops}
        loading={isLoading}
        onClick={() => deleteCategorie(this)}
        handleToggle={handleSynchronisationToggle}
        component={this}
        text={'Sélectionnez les magasins dont vous voulez supprimer cette liste d`option:'}
        title={'Supprimer cette liste d`option:'}
        isSuppression={true}
      />
    );
  };
  render() {
    const { categories = {}, showHelpModal, classes, shopId } = this.props;
    const { showAddCategoryModal, category, items, showModal } = this.state;
    return (
      <div className='px-4 pb-4 noselect'>
        <Title title={`Liste d'options`} onClick={() => showHelpModal('options')} />
        {isObjectNotEmpty(categories) ? (
          <>
            <div className='row'>{this.renderCreateCategoryButton()}</div>
            {this.createTableRow()}
            <TableFooter
              rowsPerPageOptions={[10, 20, 50]}
              lengthOption={_.keys(categories).length}
            />
          </>
        ) : (
          <EmptyView
            className={classes.svg}
            src={ImportedSVG}
            viewBox='0 0 256 256'
            title={EMPTY_DESIGN_OPTIONS_TITLE}
            text={EMPTY_DESIGN_OPTIONS_TEXT}
          >
            {this.renderCreateCategoryButton()}
          </EmptyView>
        )}
        {showAddCategoryModal && (
          <CategoryModal
            createCategorie={this.state.createCategorie}
            isOpen={showAddCategoryModal}
            category={category}
            items={items}
            closeModal={() => closeModal(this)}
          />
        )}
        {showModal && this.renderShops(classes, shopId)}
      </div>
    );
  }
}

function mapStateToProps({ firebaseRealTime, page, user }) {
  const { shops = {}, menu = {} } = firebaseRealTime;
  const { shopId, nbShops } = user;
  const { categories = {} } = menu;
  return {
    categories,
    page,
    shopId,
    nbShops,
    shops,
    menu
  };
}

export default connect(mapStateToProps, actions)(withStyles(styles)(Categories));
